import { IconSpinner } from './Icons';

export default function LoadingSpinner({ label = '載入中' }: { label?: string }) {
  return (
    <div role="status" className="min-h-screen flex flex-col items-center justify-center gap-3 bg-white text-muted">
      <IconSpinner size={28} className="text-primary" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
